import React from 'react'
import clsx from 'clsx'

import { Plus16 } from '@makyoapp/makyo-icon/icon'

export function RepeaterButton({
  id,
  onClick,
  children,
  disabled,
}: {
  id?: string
  onClick: () => void
  children?: React.ReactNode
  disabled?: boolean
}) {
  return (
    <button
      disabled={disabled}
      id={id}
      className={clsx(
        'w-full border border-dashed bdr flex-cc h-10 p-2 rounded-sm',
        'bg-zinc-200 dark:bg-slate-900 dark:hover:bg-slate-700',
        !disabled ? 'hover:bg-zinc-300 ' : 'opacity-50'
      )}
      onClick={onClick}
    >
      <Plus16 />
      {children}
    </button>
  )
}
